import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpBaseService } from "../services/httpBase.service";
import api from "../api";
import { GetStore, GetSessionStore } from "../services/comment";
import { DomSanitizer } from "@angular/platform-browser";
import { Router, NavigationEnd } from "@angular/router";
import { window } from "rxjs/operator/window";

@Component({
  selector: "app-news-list",
  templateUrl: "./news-list.component.html",
  styleUrls: ["./news-list.component.less"]
})
export class NewsListComponent implements OnInit {
  certificate = JSON.parse(GetSessionStore("successLoginInfo")).certificate;
  type: string;
  list:any;
  newType: string;
  _current: number;
  _total: number;
  isSpinning:any;
  systemNameList: Array<string>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpBaseService,
    private sanitizer: DomSanitizer
  ) {
    this.list=[]
    this.isSpinning=true
    this.type = this.route.params["value"].type;
    this._current = 1;
    this.systemNameList = [];
  }

  ngOnInit() {
    if (this.type === "NEWS") {
      this.newType = "公司新闻";
    } else {
      this.newType = "通知公告";
    }
    let ssoList = JSON.parse(GetSessionStore("successLoginInfo"));
    if (ssoList.ssoSystems !== undefined) {
      ssoList.ssoSystems.map((item, key) => {
        this.systemNameList.push(item["systemCode"]);
      });
    }
    console.log(this.systemNameList.indexOf('SAM'))
    if(this.systemNameList.indexOf('SAM')==-1){
      this.systemNameList.push('SAM');
    }
    this.getNews();
  }
  to(data) {
    this.router.navigate([`news/${data.articleId}`]);
  }
  page() {
    this.getNews();
  }
  getNews() {
    console.log(this.systemNameList)
    this.http
      .post(api.newsFind, {
        params: JSON.stringify({
          articleType: this.type,
          isPortal:'Y',
          systemCode: this.systemNameList.join(",")
        }),
        pageIndex: this._current,
        pageRows: 10
      })
      .subscribe(res => {
        this.isSpinning=false
        this.list = res.data;
        this._total = res.count;
      });
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/news-list/news-list.component.ts